export default __webpack_public_path__ + "static/media/playstation_background.6d6a454e.jpg";